// import React, { useState, useEffect } from "react";
// import { Link, useNavigate } from "react-router-dom";

// const Navbar = ({ onLogout }) => {
//   const [user, setUser] = useState(null);
//   const navigate = useNavigate(); // For redirection

//   useEffect(() => {
//     // Get the user from localStorage
//     const loggedInUser = JSON.parse(localStorage.getItem("user"));
//     setUser(loggedInUser);
//   }, []);

//   const handleLogout = () => {
//     localStorage.removeItem("user"); // Remove user data from localStorage
//     setUser(null); // Clear user state
//     navigate("/"); // Redirect to the login page
//   };

//   return (
//     <section className="container row">
//       <div className="col-md-12">
//         <nav className="navbar navbar-expand-md navbar-light bg-light">
//           <a href="/" className="navbar-brand">
//             <b className="text-danger " style={{fontSize:"20px"}}>Daily<span className="text-info">Yoghurts</span></b>
//           </a>
//           <button
//             className="navbar-toggler"
//             data-bs-toggle="collapse"
//             data-bs-target="#navbarcollapse"
//           >
//             <span className="navbar-toggler-icon"></span>
//           </button>

//           <div className="collapse navbar-collapse" id="navbarcollapse">
//             <div className="navbar-nav">
//               {/* Links to Get Lands and Add Lands */}
//               <Link to="/" className="nav-link">
//                 Get Products
//               </Link>
//               {  user && 

//                 <Link to="/add-product" className="nav-link">
//                 Add Products
//               </Link>
//               }
//             </div>
//             <div className="ms-auto">
//               {/* Display logged-in user's name/email and Logout button */}
//               {user ? (
//                 <div className="navbar-nav ml-auto">
//                   <span className="navbar-text me-3">
//                     Logged in as: {user.username || user.email}
//                   </span>
//                   <button
//                     className="btn btn-outline-primary ml-2"
//                     onClick={handleLogout}
//                   >
//                     Logout
//                   </button>
//                 </div>
//               ) : <div className="navbar-nav ml-auto">
             
//                   <Link to="/signin" className="btn btn-outline-primary me-2">Sign In</Link>
//                   <Link to="/signup" className="btn btn-primary ">Sign Up</Link>

//             </div>}
//             </div>
//           </div>
//         </nav>
//       </div>
//     </section>
//   );
// };

// export default Navbar;

import React, { useState, useEffect } from "react";
import { Link, useNavigate } from "react-router-dom";
import { FaShoppingCart } from "react-icons/fa";

const Navbar = () => {
  const [user, setUser] = useState(null);
  const [cartCount, setCartCount] = useState(0);
  const navigate = useNavigate();

  useEffect(() => {
    // Load user
    const loggedInUser = JSON.parse(localStorage.getItem("user"));
    setUser(loggedInUser);

    // Load cart count
    const savedCart = JSON.parse(localStorage.getItem("cart")) || [];
    setCartCount(savedCart.length);
  }, []);

  const handleLogout = () => {
    localStorage.removeItem("user");
    setUser(null);
    navigate("/");
  };

  return (
    <section className="container row">
      <div className="col-md-12">
        <nav className="navbar navbar-expand-md navbar-light bg-light shadow-sm">
          <Link to="/" className="navbar-brand">
            <b className="text-danger" style={{ fontSize: "20px" }}>
              Daily<span className="text-info">Yoghurts</span>
            </b>
          </Link>
          <button
            className="navbar-toggler"
            data-bs-toggle="collapse"
            data-bs-target="#navbarcollapse"
          >
            <span className="navbar-toggler-icon"></span>
          </button>

          <div className="collapse navbar-collapse" id="navbarcollapse">
            <div className="navbar-nav">
              <Link to="/" className="nav-link">
                Get Products
              </Link>

              {user && (
                <Link to="/add-product" className="nav-link">
                  Add Products
                </Link>
              )}
            </div>

            <div className="ms-auto d-flex align-items-center gap-3">
              {/* Cart Icon */}
              <Link to="/cart" className="btn btn-outline-primary position-relative">
                <FaShoppingCart size={20} />
                {cartCount > 0 && (
                  <span className="position-absolute top-0 start-100 translate-middle badge rounded-pill bg-danger">
                    {cartCount}
                  </span>
                )}
              </Link>

              {/* User Actions */}
              {user ? (
                <div className="navbar-nav d-flex align-items-center">
                  <span className="navbar-text me-3 text-muted">
                    Logged in as: {user.username || user.email}
                  </span>
                  <button className="btn btn-outline-primary" onClick={handleLogout}>
                    Logout
                  </button>
                </div>
              ) : (
                <div className="navbar-nav">
                  <Link to="/signin" className="btn btn-outline-primary me-2">
                    Sign In
                  </Link>
                  <Link to="/signup" className="btn btn-primary">
                    Sign Up
                  </Link>
                </div>
              )}
            </div>
          </div>
        </nav>
      </div>
    </section>
  );
};

export default Navbar;
